import Slider from "react-slick";
import { useRef, useState } from "react";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import PronouncementCard, { PostData } from "./components/PronouncementCard";
import { useNavigate } from "react-router-dom";

interface Props {
  data: PostData[];
}

export default function Pronouncement({ data }: Props) {
  const navigate = useNavigate();
  const [selectedIndex, setSelectedIndex] = useState(2);

  const handlePrev = () => {
    setSelectedIndex((prev) => (prev === 0 ? data.length - 1 : prev - 1));
  };

  const handleNext = () => {
    setSelectedIndex((prev) => (prev === data.length - 1 ? 0 : prev + 1));
  };

  return (
    <section className="w-full bg-gradient-to-r from-[#296E98] to-[#45B7FE] text-white overflow-hidden">
      <div className="flex lg:flex-row gap-30 items-center justify-evenly">
        {/* Texto à esquerda */}
        <div className="text-center lg:text-left flex flex-col items-center py-16 md:px-6">
          <p className="w-2xl text-xl md:text-4xl font-medium mb-6 leading-relaxed">
            Veja o que dizem as autoridades e confira as últimas novidades no
            setor de crédito de carbono.
          </p>
          <button
            onClick={() => navigate("/pronouncement")}
            className="!bg-green-200 !text-green-800 !px-6 !py-2 rounded-md font-semibold hover:bg-green-300 transition !mt-10"
          >
            Pronunciamentos
          </button>
        </div>

        {/* Carrossel à direita */}
        <div className="flex flex-col items-center gap-4">
          <div className="flex items-center gap-4">
            <button
              onClick={handlePrev}
              className="text-2xl bg-white shadow p-2 rounded-full"
            >
              ◀
            </button>

            <div className="relative w-[400px] h-[200px] perspective-[1000px] overflow-hidden">
              <div className="relative w-full h-full flex justify-center items-center">
                {data.map((item, index) => {
                  const offset = index - selectedIndex;
                  const visible = Math.abs(offset) <= 2;

                  const transform = `
                translateX(${offset * 120}px)
                scale(${offset === 0 ? 1 : 0.75})
                rotateY(${offset * 25}deg)
              `;

                  return (
                    <div
                      key={index}
                      className={`absolute flex items-center justify-center text-4xl bg-white rounded-xl shadow-md transition-all duration-500 ease-in-out ${
                        visible ? "opacity-100" : "opacity-0"
                      }`}
                      style={{
                        transform,
                        zIndex: 100 - Math.abs(offset),
                      }}
                    >
                      <PronouncementCard data={item} />
                    </div>
                  );
                })}
              </div>
            </div>

            <button
              onClick={handleNext}
              className="text-2xl bg-white shadow p-2 rounded-full"
            >
              ▶
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}
